const setPage = (state, action) => action.page || state;

export default setPage;
